import { defaultAvailabilityMonths } from './validation';

export const certificationMap: Record<string, string> = {
  'AUDITORIA': 'CERTIFICAÇÃO POR AUDITORIA (OCS)',
  'SISTEMA_PARTICIPATIVO': 'SISTEMA PARTICIPATIVO DE GARANTIA (SPG)',
  'CONTROLE_SOCIAL': 'CONTROLE SOCIAL EM VENDA DIRETA'
};

export const reverseCertificationMap: Record<string, string> = Object.fromEntries(
  Object.entries(certificationMap).map(([key, value]) => [value, key])
);

export function parseAvailabilityMonths(raw: any) {
  if (!raw) return undefined;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return parsed;
    } catch (e) {
      return undefined;
    }
  }
  if (typeof raw === 'object') return raw;
  return undefined;
}

export function mapApiProductToProdutoSelecionado(p: any) {
  const availabilityMonths = parseAvailabilityMonths(p.available_months) ?? defaultAvailabilityMonths;
  return {
    uuid: p.uuid,
    name: p.custom_product_name ?? p.product_id ?? 'Produto Convencional',
    selecionado: true,
    expandido: false,
    production_area_hectares: parseFloat(p.area_hectares) ?? null,
    volume_produced: parseFloat(p.volume_produced) ?? null,
    volume_produced_unit: p.volume_produced_unit,
    volume_commercialized: parseFloat(p.volume_commercialized) ?? null,
    volume_commercialized_unit: p.volume_commercialized_unit,
    average_commercialized_value: parseFloat(p.commercialized_value) ?? null,
    volume_self_consumption: parseFloat(p.volume_consumed_donated) ?? null,
    volume_self_consumption_unit: p.volume_self_consumption_unit,
    volume_lost: parseFloat(p.volume_lost) ?? null,
    volume_lost_unit: p.volume_lost_unit,
    is_processed: p.is_processed || false,
    production_type: p.production_type,
    product_type: p.product_type,
    availability_months: availabilityMonths
  };
}

export function mapProductListItemToProdutoSelecionado(produto: any) {
  return {
    uuid: produto.uuid,
    name: produto.name,
    selecionado: false,
    expandido: false,
    production_area_hectares: null,
    volume_produced: null,
    volume_produced_unit: produto.volume_produced_unit,
    volume_commercialized: null,
    volume_commercialized_unit: produto.volume_commercialized_unit,
    average_commercialized_value: null,
    volume_self_consumption: null,
    volume_self_consumption_unit: produto.volume_self_consumption_unit,
    volume_lost: null,
    volume_lost_unit: produto.volume_lost_unit,
    is_processed: produto.is_processed,
    production_type: produto.production_type,
    product_type: produto.product_type,
    availability_months: defaultAvailabilityMonths
  };
}
